import http from "./httpService";

const endPoint = "/api/v1/Notifications";

export function getNotifications(take, skip) {
    return http.get(endPoint, { params: { take, skip }});
}

export function readNotification(id, isRead){
    return http.patch(`${endPoint}/${id}/Read`, { isRead });
}

const obj = {
    getNotifications,
    readNotification
};

export default obj;


// WEBPACK FOOTER //
// ./src/services/notificationsService.js